import React from 'react'
import ButtonComponent from './ButtonComponent'
import { Button, Modal } from 'react-bootstrap';

const ModalComponent = ({ title,
    show,
    close,
    children,
    idForm,
    // size = 'md',
    props,
    isLoading = false,
}) => {
    // const [show, setShow] = React.useState(false);
    // const handleClose = () => setShow(false);
  return (
    <Modal alignment="center" show={show} onHide={close} size={'lg'}>
        <div className="modal-header align-items-center"
        style={{ background: 'blue', color: 'white', borderBottom: 'none' }}
        >
            <p className="modal-title">
            <i className='fa fa-plus'></i>
            &nbsp;{title}
            </p>
            <ButtonComponent
            onClick={close}
            color="#fff"
            backgroundColor="transparent"
            backgroundHover="grey"
            >
            X
            </ButtonComponent>
        </div>
        <Modal.Body className='modal-body' style={{color: 'white'}}>{children} </Modal.Body>
        <Modal.Footer className='modal-footer' style={{ borderTop: 'none'}}>
            <ButtonComponent  
                color="white"
                backgroundColor="#3003fc"
                backgroundHover="#2404b5"
                type="submit" 
                form={idForm} 
            >
                <i className="fa fa-plus-circle me-1" size="sm" />
                    &nbsp;Simpan
            </ButtonComponent>
            <ButtonComponent 
                color="white"
                backgroundColor="#fc030f"
                backgroundHover="#b50407" 
                onClick={close}
            >    
                <i className="fa fa-ban me-1" size="sm" />
                    &nbsp;Batal
            </ButtonComponent>
        </Modal.Footer>
    </Modal>
  )
}

export default ModalComponent